import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { ChangeEvent, FocusEvent, useState } from 'react';
import { designConstants as design } from 'styles/designConstants';

export interface IInputMethodProps {
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  fullWidth?: boolean;
  required?: boolean;
}

export interface IGeneralInputProps {
  autoFocus?: boolean;
  label?: string;
  name: string;
  testidProp: string;
  type?: string;
  value?: string;
  onKeyUp?: Function;
  error?: boolean;
  helperText?: string;
  id?: string;
}

const useStyles = makeStyles({
  root: {
    borderRadius: '3px 3px 0px 0px',
    margin: '7px 0px',

    '& .Mui-error': {
      '& .MuiInputBase-input': {
        borderBottomColor: design.color.$red_dark,
      },
    },

    '& .MuiFormHelperText-root': {
      color: design.color.$red_dark,
    },

    '& .MuiInputBase-input': {
      '&[type=login]': { backgroundColor: design.color.$white_full },
      '&[type=password]': { backgroundColor: design.color.$white_full },

      fontSize: '17px',
      lineHeight: '21px',
      borderBottom: '2px solid',
      borderBottomColor: (props: any) =>
        props.color || `rgba(${design.color.$teal_base}, 1)`,
    },
  },

  label: {
    fontSize: '17px',

    '&.MuiInputLabel-shrink': {
      color: (props: any) =>
        props.color || `rgba(${design.color.$teal_base}, 1)`,

      '&.Mui-error': {
        color: design.color.$red_dark,
      },
    },
  },

  error: {
    display: 'inline-flex',
    marginTop: '0px',
  },
});

export const InputGeneral = (props: generalOptions) => {
  const classes = useStyles();
  const {
    autoFocus,
    label,
    onBlur,
    onChange,
    name,
    testidProp,
    type,
    value,
    fullWidth = true,
    error,
    helperText,
    id,
    required = false,
  } = props;

  return (
    <TextField
      id={error ? id : ''}
      helperText={error ? helperText : ''}
      error={error}
      autoFocus={autoFocus || false}
      className={classes.root}
      fullWidth={fullWidth}
      // These are different. inputProps checks element attributes
      // InputProps passes props down to the Input component
      inputProps={{ 'data-testid': testidProp }}
      InputProps={{ disableUnderline: true }}
      InputLabelProps={{ className: classes.label }}
      label={label}
      name={name}
      type={type || 'input'}
      value={value || ''}
      variant="filled"
      onBlur={onBlur}
      onChange={onChange}
      required={required}
    />
  );
};

type generalOptions = IInputMethodProps & IGeneralInputProps;

//* -----------------------------------------------
// for BirthDate input
//* -----------------------------------------------

export const ERR_MESSAGE_BIRTH_DATE_FORMAT = 'Invalid Date format (MM-DD-YYYY)';

// value attributes are set at the parent level; defaults to typed input
export const InputEmail = ({
  onBlur,
  onChange,
  value,
  isValid,
  required = false,
}: IInputMethodProps & IEmailProps) => {
  const [isFocused, setFocus] = useState(false);
  const classes = useStyles({
    color: !isValid ? design.color.$red_dark : undefined,
  });

  return (
    <TextField
      className={classes.root}
      error={!isValid}
      type="input"
      fullWidth
      inputProps={{ 'data-testid': 'email-input' }}
      InputProps={{ disableUnderline: isFocused }}
      InputLabelProps={{ className: classes.label }}
      label="Email"
      name="email"
      value={value || ''}
      variant="filled"
      onBlur={onBlur}
      onFocus={() => setFocus(true)}
      onChange={onChange}
      required={required}
    />
  );
};

interface IEmailProps {
  value: string;
  isValid: boolean;
}

export default InputGeneral;
